import React from 'react';
import '../Style/popUp.css';
import closeIcon from '../images/close popup.png';
import {_SYSTEM_TITLES} from '../../../configuration/index.config';
import {AccuracyTemplate} from '../../VersionItem';
import ArrowTooltips from '../../ToolTip';
import utilService from '../../../services/utilService';
import LabelIcon from '@mui/icons-material/Label';
import SubdirectoryArrowRightIcon from '@mui/icons-material/SubdirectoryArrowRight';

const AccuracyInsights = ({close, accuracy, insights, versionNumber, feature, maxLenString, id, onClick, isCanOpenEvalImages}) => {
    const showInsights = (insight) => {
        const type = insight.insight_type;
        const insightsList = insight.bad_classes;
        const typeCase = (type === 'few_instances_sub_component' || type === 'low_score_sub_component') ? 'labels' : 'tags';

        switch (typeCase) {
            case 'labels':
                // @ts-ignore
                return (
                    <div className='insights-list'>
                        {insightsList.map((subInsight, i) => (
                            <div className='insight-item-label' key={i}>
                                <span>
                                    <LabelIcon fontSize={'small'}/>
                                </span>
                                <span>{subInsight.label}</span>
                                {subInsight.attribute && (
                                    <>
                                        <SubdirectoryArrowRightIcon fontSize={'small'} />
                                        <span>{subInsight.attribute}</span>
                                    </>
                                )}
                                {'score' in subInsight ? (
                                    <span className='accuracy-btn-label'>
                                        <AccuracyTemplate
                                            id={id}
                                            label={subInsight.label}
                                            attribute={subInsight.attribute}
                                            onClick={onClick}
                                            isCanOpenEvalImages={isCanOpenEvalImages}
                                            accuracy={subInsight.score}
                                            featureName={feature}
                                            featureVersionNumber={versionNumber}
                                        />
                                    </span>
                                ) : (
                                    <span> - </span>
                                )}
                                {'num_instances' in subInsight && (
                                    <>
                                        <span>{_SYSTEM_TITLES.insightsNumOfImages}</span>
                                        <span className='strong'>{subInsight.num_instances}</span>
                                        <span> instances</span>
                                    </>
                                )}
                            </div>
                        ))}
                    </div>
                );
            case 'tags':
                return (
                    <div className='insights-list'>
                        <span>{`${_SYSTEM_TITLES.tags}: `}</span>
                        {insightsList.map((subInsight, i) =>
                            <div className='insight-item-tag' key={i}>
                                <span className='strong'>{subInsight.tags.join(', ')}</span>
                                {'score' in subInsight ? <span>
                                    <AccuracyTemplate
                                        id={id}
                                        tags={subInsight.tags}
                                        onClick={onClick}
                                        isCanOpenEvalImages={isCanOpenEvalImages}
                                        featureName={feature}
                                        featureVersionNumber={versionNumber}
                                        accuracy={subInsight.score}/></span> : <span> - </span>}
                                {'num_instances' in subInsight &&
                                    <>
                                        <span>{_SYSTEM_TITLES.insightsNumOfImages}</span>
                                        <span className='strong'>{subInsight.num_instances}</span>
                                        <span> instances</span>
                                    </>}
                            </div>)}
                    </div>);
            default:
                return <></>;
        }
    };

    return (
        <div className='popup-warning'>
            <div className='accuracy-popup-container'>
                <img className='close' src={closeIcon} alt='close popup' onClick={close}/>
                <div className='accuracy-popup-inner-container'>
                    <p className='accuracy-popup-title'>{_SYSTEM_TITLES.trainingInsightsTitle}</p>
                    <div className='grid-accuracy'>
                        <p className='grid-accuracy-title'>{_SYSTEM_TITLES.feature}</p>
                        <p className='grid-accuracy-title'>{_SYSTEM_TITLES.versionTtile}</p>
                        <p className='grid-accuracy-title'>{_SYSTEM_TITLES.accuracy}</p>
                        <ArrowTooltips title={feature && feature.length > maxLenString ? <p className='tool-tip-list'>{feature}</p> : ''} placement='top' >
                            <p className='grid-accuracy-col'>{`${utilService.normalizedSting(feature, maxLenString)}`}</p>
                        </ArrowTooltips>
                        <p className='grid-accuracy-col grid-accuracy-v'>{`v${versionNumber}`}</p>
                        <AccuracyTemplate featureName={feature} accuracy={accuracy} id={id} onClick={onClick} featureVersionNumber={versionNumber} isCanOpenEvalImages={isCanOpenEvalImages}/>
                    </div>
                    <div className='accuracy-popup-insights-container'>
                        {insights.map((insight, i) => <React.Fragment key={i}>
                            {(insight.insight_type === 'low_score_sub_component' || insight.insight_type === 'low_score_classification') &&
                                    <>
                                        <p className='training-data-title'>{_SYSTEM_TITLES.insightsListTitleTrainingBig}</p>
                                        <p className='insight-item-title'>{_SYSTEM_TITLES.insightsListTitleTraining}</p>
                                    </>
                            }
                            {(insight.insight_type === 'few_instances_sub_component' || insight.insight_type === 'few_instances_classification') &&
                                <>
                                    <p className={`${i > 0 ? 'evaluationBig-data-title' : 'training-data-title'}`}>{_SYSTEM_TITLES.insightsListTitleEvaluationBig}</p>
                                    <p className='insight-item-title'>{_SYSTEM_TITLES.insightsListTitleEvaluation}</p>
                                </>
                            }
                            {showInsights(insight)}
                            {insight.insight_type === 'low_score_sub_component' && <p className='insight-item-title'>{_SYSTEM_TITLES.insightsListTitleTrainingSub}</p>}
                        </React.Fragment>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AccuracyInsights;
